module.exports = __webpack_public_path__ + "static/media/phone-alt-light1.dbaac9f1.svg";